// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__k1_ut","simple_loading":"loader_simple_loading__JrBP6","spin":"loader_spin__gimJS","pulse":"loader_pulse__YBKcO"};